import React, { useEffect, useState } from "react";import { Box,end, duration, Card,useMediaQuery, CardContent, CardMedia, Typography, Paper, Grid, Divider } from '@mui/material';
import About from './About';
import DoctorProfile
 from './Bio';
import { motion } from "framer-motion";
import ReviewsCarousel from "./Reviews";

const Counter = ({ end, duration }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const increment = end / (duration * 60);
    const timer = setInterval(() => {
      start += increment;
      if (start >= end) {
        setCount(end);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 1000 / 60);
    return () => clearInterval(timer);
  }, [end, duration]);

  return (
    <motion.span
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
    >
      {count.toLocaleString()}
    </motion.span>
  );
};

const StatsSection = () => {
  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        justifyContent: "space-evenly",
        alignItems: "center",
        backgroundColor: "white",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        borderRadius: "15px",
        margintop : 2,
        padding: isMobile ? "20px" : "30px",
        gap: isMobile ? "15px" : "0",
        maxWidth: "100%",
        margin: "auto",
      }}
    >
      {/* Quality Care
      <Box textAlign="center">
        <Typography variant={isMobile ? "h5" : "h4"} fontWeight="bold" color="#0279c6">
          <Counter end={100} duration={2} />%
        </Typography>
        <Typography variant="body1" color="#0D1B2A">Quality Care</Typography>
      </Box>

      {/* Happy Patients */}
      {/* <Box textAlign="center"> */}
        {/* <Typography variant={isMobile ? "h5" : "h4"} fontWeight="bold" color="#0279c6"> */}
          {/* <Counter end={5000} duration={2.5} />+ */}
        {/* </Typography> */}
        {/* <Typography variant="body1" color="#0D1B2A">Happy Patients</Typography> */}
      {/* </Box> */}

      {/* Experience */}
      {/* <Box textAlign="center"> */}
        {/* <Typography variant={isMobile ? "h5" : "h4"} fontWeight="bold" color="#0279c6"> */}
          {/* <Counter end={5} duration={1.5} */}
        {/* </Typography> */}
        {/* <Typography variant="body1" color="#0D1B2A">Years Experience</Typography> */}
      {/* </Box> */}  

      <Box textAlign="center">
        <Typography variant={isMobile ? "h6" : "h5"} fontWeight="bold" color="#0279c6">
    “Minimally invasive and robotic surgery are game-changers in cancer care—helping patients
recover faster with fewer complications, without compromising on outcomes"
        </Typography>
        </Box> 
   </Box>
  );
};



const VerticalTimeline = () => {
    const milestones = [
        {
            year: '2013 - 2014',
            description: 'Internship/Housemanship at GOVT. Siddhartha Medical College, Government General Hospital, Vijayawada',
            image: 'assets/images/tarun_reddy.jpeg',  // Image for M.B.B.S
            side: 'left',
        },
        {
            year: '2014 - 2017',
            description: 'Post Graduate Trainee at St Theresa Hospital, Sanath Nagar, Hyderabad',
            image: '/assets/images/photo1.jpeg', // Image for Residency
            side: 'right',
        },
        {
            year: '2017 - 2018',
            description: 'Dr.Tarun was in clinical practise as Senior and Junior resident in various Medical Colleges i.e, Kamineni Institute of Medical Sciences, Hyderabad, Government Medical College, Nizamabad, Apollo Medical College, Hyderabad.',
            image: '/assets/images/photo4.jpeg', // Image for Consultant position
            side: 'left',
        },
        {
            year: '2018 - 2029',
            description: 'Senior Resident Doctor in General Surgery at the prestigious ESIC Medical College, Sanathnagar, Hyderabad. The hospital, covering an expansive area of 1.2 million square feet, boasts a 800-bed capacity and is equipped with a comprehensive range of specialties and superspecialties.',
            side: 'right',
            image: '/assets/images/photo4.jpeg', // Image for Consultant position
        },
        {
            year: '2019 - 2022',
            description: 'Senior Resident Doctor in department of Surgical Oncology in Gujarat Cancer Research institiute [GCRI], B.J.Medical College, Ahmedabad.',
            image: '/assets/images/photo3.jpeg', // Image for Robotic Surgery
            side: 'left',
        },
        {
            year: '2022 - 2023',
            description: 'Assistant Professor at B. J. Medical College (BJMC), Department of Surgical Oncology Ahmedabad. The B. J. Medical College (BJMC), Ahmedabad is one of the largest sources of medically qualified manpower in the country.',
            image: '/assets/images/photo3.jpeg', // Image for Robotic Surgery
            side: 'right',
        },
    ];

    return (
        <Box sx={{ width: '100%', position: 'relative' }}>
            <DoctorProfile></DoctorProfile>
            <StatsSection></StatsSection>
            <ReviewsCarousel></ReviewsCarousel>
            <Typography variant="h4" fontWeight="bold" align="center" paddingBottom="40px" pt="30px" gutterBottom>
                Professional Timeline
            </Typography>
            <Box sx={{ position: "relative" }}>


                {/* Vertical Line */}
                <Box sx={{
                    position: "absolute", top: 0, left: '50%', transform: 'translateX(-50%)',
                    width: '2px', height: '100%', backgroundColor: 'black', zIndex: 0,
                }}></Box>

                <Grid container direction="column" spacing={6}>
                    {milestones.map((milestone, index) => (



                        <Grid item key={index} sx={{ position: 'relative', display: 'flex', justifyContent: milestone.side === 'left' ? 'flex-end' : 'flex-start' }}>
                            {/* Image */}



                            <Card sx={{ width: "50%", height: 400, backgroundColor: "#4cadd4" }}>
                                <Typography
                                    variant="h2"
                                    sx={{
                                        color: "black", // Adjust the text color for visibility on the image
                                        textAlign: milestone.side === 'left' ? "left" : "right",
                                        // Optional: makes the text bold
                                    }}
                                >
                                    {milestone.year}
                                </Typography>

                                <CardMedia component="img" image={milestone.image} sx=
                                    {{
                                        xs: "100%", md: "80%", // Full width on small screens, limited on larger
                                        height: "60%"
                                    }}>


                                </CardMedia>
                                <CardContent >
                                    <Typography
                                        variant="h3"
                                        sx={{
                                            position: "relative",
                                            color: "black", // Adjust the text color for visibility on the image
                                            // Optional: makes the text bold
                                            backgroundColor:"#4cadd4",
                                            flexWrap: "wrap",
                                            textAlign: "left",
                                        }}
                                    >
                                        {milestone.description}
                                    </Typography>

                                </CardContent>

                            </Card>

                            {index < milestones.length - 1 && <Divider sx={{ marginTop: 2 }} />}
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Box>
    );
};

export default VerticalTimeline;
